import { TableColumn } from './types';

export function getTableColumns<Entity>(config: TableColumn<Entity>[]): TableColumn<Entity>[] {
  return config;
}

export function slicePage<E>(items: E[], page: number, itemsPerPage: number): E[] {
  const initialIndex = itemsPerPage * page;
  const endIndex = itemsPerPage * (page + 1);

  return items.slice(initialIndex, endIndex);
}
